import * as React from "react"
import {
    ColumnDef,
} from "@tanstack/react-table"
import { useEffect, useState } from "react";
import { Pagination } from "../pagination";
import { ReactTable } from "../react-table/react-table";
import styles from "./pagination-table.module.scss";
import cn from "classnames";

interface IPaginationTableProps<T> {
    className?: string;
    data: T[]
    columns: ColumnDef<T, any>[];
    onPageChange?: (page: number) => void;
    limit?: number;
    loading?: boolean;
    tableClassName?: string;
}

export function PaginationTable<T>({
                                       data,
                                       className,
                                       columns,
                                       onPageChange,
                                       tableClassName,
                                       loading = false,
                                       limit = 10
                                   }: IPaginationTableProps<T>) {
    const [currentPage, setCurrentPage] = useState(1);
    const [pageCount, setPageCount] = useState(1);
    const [displayedData, setDisplayedData] = useState<T[]>([]);

    useEffect(() => {
        const pagesCount = Math.ceil(data.length / limit)
        setPageCount(pagesCount);
    }, [data, limit])

    useEffect(() => {
        if (loading === false) {
            setCurrentPage(1);
        }
    }, [loading])

    useEffect(() => {
        setDisplayedData(data.slice(((currentPage - 1) * limit), (currentPage * limit)));
    }, [data, limit, currentPage])

    const onCurrentPageChange = (page: number) => {
        setCurrentPage(page);
        onPageChange && onPageChange(page);
    }

    return (
        <div className={cn(styles.container, className)}>
            <ReactTable<T> data={displayedData} columns={columns} className={tableClassName} loading={loading}/>
            <Pagination
                currentPage={currentPage}
                floatPageRegionSize={3}
                onPageChange={onCurrentPageChange}
                pagesCount={pageCount}
            />
        </div>
    )
}
